module.exports = __webpack_public_path__ + "static/media/mimi1.477fc8dd.gif";